"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROOT_SCOPE_VARIABLES = void 0;
exports.ROOT_SCOPE_VARIABLES = {
    ORDER: {
        NEW_ORDER: 'app.orders.neworder',
        NEW_ORDER_PANEL: 'app.orders.neworderpanel',
    },
    LANGUAGE: {
        SELECTED_LANGUAGE: 'app.language.set',
    }
};
